<div id="popup">
  <div class="title-head index-head" fxLayout="row" fxLayoutAlign="space-between center">
    <span>
      Advance Filter
    </span>
    <button [attr.guide]="'advance-filter-btn-1-1' + '__' + sanitizeUrl(url)" mat-icon-button>
      <mat-icon (click)="close()">
        close
      </mat-icon>
    </button>
  </div>
  <mat-dialog-content [ngStyle.lt-md]="'max-height: 100%'" style=" MARGIN: 0PX; padding: 0px;">

    <div class="padding-11">

      <div fxLayout="column">

        <div class="Advance">

          <div *ngIf="init">

            <form [formGroup]="_form">

              <ng-container formArrayName="data">
                <ng-container *ngFor="let dataItem of dataFormArray.controls; let di = index" [formGroupName]="di"
                  style="border: 1px solid #ccc; padding: 10px; margin-bottom: 15px;">

                  <div style="width: 100%; margin-bottom: 15px;">

                    

                    <mat-form-field appearance="outline"  fxFlex="100%">
                      <mat-label>Type</mat-label>
                      <mat-select
                     
                      formControlName="type">
                        <mat-option *ngFor="let item of type"    [disabled]="
                        dataItem.get('value')?.value?.[0]?.statement?.groups?.[0]?.conditions?.length > 0
                      " [value]="item.value">
                          {{item.viewValue}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <button [attr.guide]="'advance-filter-btn-2-1' + '__' + sanitizeUrl(url)" mat-icon-button 
                      [disabled]="di === 0" (click)="deleteDataBlock(di)">
                      <mat-icon>delete</mat-icon>
                    </button>

                  </div>

                  <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start stretch" style="flex-wrap: wrap;">
                    <ng-container formArrayName="value">
                      <ng-container *ngFor="let valueItem of getValueFormArray(di).controls; let vi = index"
                        [formGroupName]="vi" style="min-width: 300px; border: 1px solid #ddd; padding: 10px;">

                        <ng-container formGroupName="statement">
                          <ng-container formArrayName="groups">
                            <ng-container *ngFor="let group of getGroupsFormArray1(di, vi).controls; let gi = index"
                              [formGroupName]="gi">
                              <calsoft-database-rule-component-advanced [type]="dataItem.get('type')?.value"
                                [formGroup]="group" (remove)="_delete1(di, vi, gi)" [ruleId]="'0'"
                                [mainForm]="_form"
                                [formLabel]="'Group ' + (gi + 1) + ':'">
                              </calsoft-database-rule-component-advanced>
                            </ng-container>
                          </ng-container>
                        </ng-container>

                      </ng-container>
                    </ng-container>
                  </div>

                </ng-container>
              </ng-container>

              <button [attr.guide]="'advance-filter-btn-3-1' + '__' + sanitizeUrl(url)" mat-raised-button color="primary" (click)="addNewData()">Add New Data</button>

            </form>

          </div>

        </div>

      </div>

      <div class="padding-top10" fxLayoutAlign="end center" fxLayoutGap="10px">

        <button [attr.guide]="'advance-filter-btn-4-1' + '__' + sanitizeUrl(url)" type="button" mat-raised-button (click)="close()">Cancel
        </button>

        <button [attr.guide]="'advance-filter-btn-5-1' + '__' + sanitizeUrl(url)" [disabled]="text !='Search'" (click)="submit()" mat-raised-button>
          {{text}}
          <mat-icon *ngIf="text !='Search' ">
            <mat-spinner color="primary" diameter="20">
            </mat-spinner>
          </mat-icon>
        </button>

      </div>
    </div>
  </mat-dialog-content>
</div>